import axios from 'axios';
import jwt_decode from "jwt-decode";
import { urlConfig } from "@/constants/urlConfig";
const API_URL = urlConfig.API_URL;

class AuthService {
  login(user) {
      console.log(user);
    return axios
      .post(API_URL + 'login', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        var user = {};
        if (response.data.success) {
          var payload = jwt_decode(response.data.token);
          console.log(payload);
          localStorage.setItem('jwt',response.data.token);
          
          user = {
            email : payload.email,
            name : payload.given_name
          };
          localStorage.setItem('user',JSON.stringify(user));
         
        }

        return user;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();